<div class="page-container">
  <h1>Willkommen in der Netzbetreiberplattform</h1>
</div>
